'use es6';

export const HUBSPOT_NAV_V3_ID = 'hs-nav-v3';
export const HUBSPOT_NAV_V4_ID = 'hs-nav-v4';
export const HUBSPOT_NAV_BEFORE_ID = 'hs-nav-before-container';
export const HUBSPOT_NAV_NO_BOTTOM_MARGIN_CLASS = 'no-bottom-margin';
export const HUBSPOT_EMAIL_CONFIRM_BAR_ID = 'hs-email-confirm-bar';
export const EMAIL_CONFIRM_ACTIONS_ID = 'hs-email-confirm-bar-actions';
export const RESEND_VERIFICATION_EMAIL_BUTTON_ID = 'hs-email-confirm-bar-resend-button';